import { useState } from "react";
import { faqs } from "@/mocks/events";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <p className="inline-flex items-center gap-2 text-sm font-bold text-secondary-700">
            <span className="h-px w-6 bg-secondary-500" />
            常见问题
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            关于追瓜，你想知道的都在这里
          </h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
            对爆炸瓜的更新机制、内容原则或投稿方式有疑问？下面集中解答读者最常问的几个问题。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="mailto:gossip@baozhagua.example.com"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-secondary-600"
            >
              <i className="ri-mail-send-line" />
              仍有疑问，联系我们
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="font-heading text-base font-bold text-foreground-950">{f.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-foreground-700"
                    }`}
                  >
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="border-l-2 border-primary-300 pl-4 text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* FAQPage structured data, mirrors the visible Q&A */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        })}
      </script>
    </section>
  );
}